import script from "./VInputTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputTag.vue?vue&type=script&setup=true&lang=ts"

import "./VInputTag.vue?vue&type=style&index=0&id=0dc5b362&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc5b362"]])

export default __exports__